import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { EventCommunityInvitee } from 'types/communities.types';

type ListEventCommunityInvitesQueryResponse = {
  eventCommunityInvites: {
    list: EventCommunityInvitee[];
  };
};

const LIST_EVENT_COMMUNITY_INVITES_QUERY = gql`
  query ListEventCommunityInvites($eventId: Int!) {
    eventCommunityInvites(eventId: $eventId) {
      list {
        id
        name
        memberCount
      }
    }
  }
`;

type DeleteEventCommunityInviteQueryResponse = {
  removeCommunityForEvent: {
    ok: boolean;
  };
};

const DELETE_EVENT_COMMUNITY_INVITE_MUTATION = gql`
  mutation DeleteEventCommunityInvite($eventId: Int!, $communityId: Int!) {
    removeCommunityForEvent(eventId: $eventId, communityId: $communityId) {
      ok
    }
  }
`;

const communityInvitesApi = {
  list: async (
    eventId: number
  ): Promise<ListEventCommunityInvitesQueryResponse['eventCommunityInvites']['list']> => {
    return gqlClient
      .request<ListEventCommunityInvitesQueryResponse>(LIST_EVENT_COMMUNITY_INVITES_QUERY, {
        eventId
      })
      .then((res) => res.eventCommunityInvites.list);
  },
  delete: async (
    eventId: number,
    communityId: number
  ): Promise<DeleteEventCommunityInviteQueryResponse['removeCommunityForEvent']['ok']> => {
    return gqlClient
      .request<DeleteEventCommunityInviteQueryResponse>(DELETE_EVENT_COMMUNITY_INVITE_MUTATION, {
        eventId,
        communityId
      })
      .then((res) => res.removeCommunityForEvent.ok);
  }
};

export { communityInvitesApi };
